import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rep-fuel-stations',
  templateUrl: './rep-fuel-stations.component.html',
  styleUrls: ['./rep-fuel-stations.component.css']
})
export class RepFuelStationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
